import { useQuery } from "react-query";
import { getGoals, getGoalsDetails } from "../../../services/performance";

export const useGetGoals = ({ queries = "" }) => {
  return useQuery(
    ["getGoals", queries],
    () => getGoals(queries).then((res) => res?.data),
    {
      staleTime: Infinity,
    },
  );
};

export const useGetGoalsDetails = ({ id }) => {
  return useQuery(
    ["getGoalsDetails", `${id}`],
    () => getGoalsDetails({ id }).then((res) => res?.data?.data),
    {
      staleTime: Infinity,
      enabled: id ? true : false,
    },
  );
};
